// -> IAccessAdministrationManager (UsersController). UC-15/UC-16.
import { http } from "./http";
import type { CallerContext, DirectoryPerson, PagedResult, RoleAssignmentRequest, SaveResult, UserProfile } from "./generated/contracts";

export interface ListUsersParams {
  readonly searchTerm?: string;
  readonly role?: string;
  readonly includeDisabled?: boolean;
  readonly pageNumber?: number;
  readonly pageSize?: number;
}

export const accessApi = {
  getCurrentUser: () => http.get<CallerContext>("/api/users/me"),

  listUsers: (params: ListUsersParams = {}) => http.get<PagedResult<UserProfile>>("/api/users", { query: { ...params } }),

  assignRole: (request: RoleAssignmentRequest) => http.put<SaveResult<UserProfile>>("/api/users/role", { body: request }),

  searchDirectory: (searchTerm: string) =>
    http.get<DirectoryPerson[]>("/api/directory", { query: { searchTerm } }),
};
